import React from 'react';

import { Alert, AlertProps } from '@mui/material';
import { Diamond, Rocket } from 'components/icons';
import { useMUIThemeModeContext } from 'context/MUIThemeModeContext';

type CustomSeverity = 'premium' | 'pro';

interface CustomAlertProps extends Omit<AlertProps, 'severity'> {
  severity?: AlertProps['severity'] | CustomSeverity;
}

const CustomAlert: React.FC<CustomAlertProps> = ({ severity, children, ...props }) => {
  const { colors } = useMUIThemeModeContext();

  const getCustomStyles = () => {
    switch (severity) {
      case 'premium':
        return {
          backgroundColor: colors.purple100,
          color: colors.purple500,
          icon: <Rocket style={{ color: colors.purple500 }} />
        };
      case 'pro':
        return {
          backgroundColor: colors.black,
          color: colors.white,
          icon: <Diamond style={{ color: colors.white }} />
        };
      default:
        return {};
    }
  };

  const customStyles = getCustomStyles();

  if (severity === 'premium' || severity === 'pro') {
    return (
      <Alert
        {...props}
        style={{ ...customStyles, ...props.style }}
        icon={customStyles.icon}
      >
        {children}
      </Alert>
    );
  }

  return (
    <Alert severity={severity as AlertProps['severity']} {...props}>
      {children}
    </Alert>
  );
};

export default CustomAlert;